export default {
  alerte: "Warnung",
  archive_label: "Archiv-Bezeichnung",
  chooseFile: "Datei auswählen",
  browse: "Durchsuchen",
  choose_profile: "Profil auswählen",
  clearFile: "Datei löschen",
  function: "Funktion",
  info: "Information",
  maximum_value: "Maximalwert",
  minimum_value: "Minimalwert",
  profile_label: "Profil-Bezeichnung",
  requiredField: "Dieses Feld ist obligatorisch",
  at_least_one_field_required: "Sie müssen mindestens eine Option in dieser Zeile ankreuzen",
  requiredNumberOrFloat: "Bitte geben Sie eine ganze oder dezimale Zahl ein",
  emailError: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
  phoneError: "Bitte geben Sie eine gültige Telefonnummer ein",
  lastName: "Nachname",
  firstName: "Vorname",
  email: "E-Mail",
  address: "Adresse",
  complement: "Ergänzung",
  postCode: "Postleitzahl",
  city: "Stadt",
  phone: "Telefon",
  mobile: "Mobil",
  actions: "Aktionen",
  rights: "Rechte",
  search_label: "Such-Bezeichnung",
  send: "Senden",
  errors: "Achtung, es gibt Fehler",
  form_validation: "Folgende Felder sind obligatorisch:",
  entitled: "Bezeichnung",
  signed_success: "Erfolgreich signiert",
  title: "Titel",
  selectValue: "Einen Wert auswählen",
  uploaded_on: "Online gestellt am",
  error_file: "Ups, die Datei scheint nicht verfügbar zu sein",
  no_skill_error_file: "Dieser Kompetenz-Import ist leer",
  download_success: "Datei erfolgreich heruntergeladen!",
  file_downloading: "Download läuft...",
  download_file: "Datei herunterladen",
  remove_file: "Datei entfernen",
  signed_error: "Ups, beim Speichern ist ein Fehler aufgetreten",
  saving: "Speicherung läuft",
  confirm: "Bestätigen",
  import: "Importieren",
  error_nofile: "Sie müssen eine Datei hinzufügen",
  error_file_format: "Bitte fügen Sie eine Datei im richtigen Format hinzu!",
  error_date: "Bitte geben Sie ein Startdatum ein, das vor dem Enddatum liegt",
  link: "Link öffnen",
  dateChoice: "Klicken Sie, um ein Datum auszuwählen",
  next: "Weiter",
  pleaseWait: "Bitte warten...",
  select: "Auswählen",
  cancel: "Abbrechen",
  save: "Speichern",
  leave_without_save: "Ohne Speichern verlassen",
  leave_confirmation: "Möchten Sie wirklich schließen ohne zu speichern?",
  ok: "OK",
  edit: "Bearbeiten",
  overview: "Vorschau",
  no: "Nein",
  verify_fields: "Felder überprüfen",
  yes: "Ja",
  warning: "Achtung",
  iConfirm: "Ich bestätige",
  Save: "Speicherung",
  saveFinish: "Die Speicherung ist abgeschlossen",
  fileFormatError: "Bitte wählen Sie eine Datei im richtigen Format aus",
  display: "Anzeigen",
  elements: "Elemente",
  lines: "Zeilen",
  pagination: {
    to: "bis",
    on: "von",
  },
  close: "Schließen",
  submit: "Senden",
  back: "Zurück",
  remove: "Entfernen",
  regenerate: "Neu generieren",
  typeYourSearch: "Suche eingeben...",
  sortBy: "Sortieren nach",
  order: "Reihenfolge",
  desc: "Absteigend",
  asc: "Aufsteigend",
  reset: "Zurücksetzen",
  filter: "Filtern",
  Search: "Suchen",
  "No data available in the table": "Keine Daten in der Tabelle verfügbar",
  "No data available": "Keine Daten verfügbar",
  "Please enter or modify your search": "Bitte geben Sie Ihre Suche ein oder ändern Sie sie",
  "Please click on the add button": "Bitte klicken Sie auf die Schaltfläche zum Hinzufügen",
  search: "Suchen",
  All: "Alle",
  None: "Keine",
  "PDF export": "PDF-Export",
  "Excel export": "Excel-Export",
  "PNG export": "PNG-Export",
  "SVG export": "SVG-Export",
  "See statistics": "Statistiken anzeigen",
  multiselect: {
    press_enter: "",
    press_enter_group: "",
    selected: "",
    press_enter_remove: "",
    press_enter_remove_group: "",
    press_enter_create_tag: "Einen Wert hinzufügen",
    select_option: "",
    no_result: "Kein Ergebnis entspricht Ihrer Suche",
    no_options: "Geben Sie mindestens {nb} Zeichen ein, um Ergebnisse zu suchen...",
  },
  init_search: "Suche zurücksetzen",
  search_motor: "Suchmaschine",
  file_size_error: "Die ausgewählte Datei ist zu groß, bitte wählen Sie eine Datei unter ",
  maxTagError: "Bitte halten Sie die maximale Anzahl der Werte ein",
  minTagError: "Bitte halten Sie die minimale Anzahl der Werte ein",
  see_more_fields: "Weitere Felder anzeigen",
  justificative_piece: "Belege",
  skillRecap: "Kompetenzübersicht",
  option_value: "Wert",
  option_label: "Label",
  light: "Hell",
  dark: "Dunkel",
  system: "System",
  valid: "Validieren",
  unlock: "Entsperren",
  tab_error: "Es gibt einen Fehler in diesem Tab",
  regenerate_succes: "Kennung erfolgreich neu generiert!",
  password_validation: {
    title: "Bitte geben Sie ein Passwort ein, das folgendes enthält:",
    condition1: "Einen Großbuchstaben",
    condition2: "Einen Kleinbuchstaben",
    condition3: "Eine Ziffer",
    condition4: "Ein Sonderzeichen",
    condition5: "Mindestens 12 Zeichen",
  },
  upload_signed_document: {
    label: "Das unterzeichnete Dokument einreichen",
    one_file: "Sie müssen mindestens 1 Datei einfügen",
    file_only: "Bitte wählen Sie eine PDF-Datei aus",
  },
};
